import { createAction } from 'redux-actions';
import reportError from 'ha/helpers/bugsnag/reportError';
import { getUserId } from 'ha/modules/AuthLogic/selectors';
import { getCountryCode, getCityCanonical } from '../selectors';
import { Actions } from '../constants';

const flow = {
  start: createAction(Actions.GET_SEARCH_ALERT_START),
  done: createAction(Actions.GET_SEARCH_ALERT_DONE),
};

export default () => (dispatch, getState, services) => {
  const state = getState();

  const userId = getUserId(state);
  const city = getCityCanonical(state);
  const countryCode = getCountryCode(state);

  if (!userId) {
    // If there is no user, do not request search alerts.
    return Promise.resolve();
  }

  dispatch(flow.start());

  return services.apiV2
    .getSearchAlerts({ userId, city, countryCode })
    .then(({ data: { alerts } }) => {
      const currentAlert = alerts.length > 0 ? alerts[0] : null;

      dispatch(flow.done({ currentAlert, error: false }));
    })
    .catch(error => {
      reportError(error, { metaData: error });
      dispatch(flow.done({ currentAlert: null, error: false }));
    });
};
